// 주차 레이아웃 — adria2
// 생성일: 2026. 3. 19.
// 그리드: 3열 × 12행

const layout = {
  meta: {
    cols: 3,
    rows: 12,
    label: 'adria2 주차장',
  },
  cells: [
    { col: 0, row: 0, type: 'spot', spot_no: 'P01' },
    { col: 1, row: 0, type: 'road' },
    { col: 2, row: 0, type: 'spot', spot_no: 'P04' },
    { col: 0, row: 1, type: 'spot', spot_no: 'P02' },
    { col: 1, row: 1, type: 'road' },
    { col: 2, row: 1, type: 'spot', spot_no: 'P05' },
    { col: 0, row: 2, type: 'pillar' },
    { col: 1, row: 2, type: 'road' },
    { col: 2, row: 2, type: 'pillar' },
    { col: 0, row: 3, type: 'spot', spot_no: 'P04' },
    { col: 1, row: 3, type: 'road' },
    { col: 2, row: 3, type: 'spot', spot_no: 'P07' },
    { col: 0, row: 4, type: 'wall' },
    { col: 1, row: 4, type: 'road' },
    { col: 2, row: 4, type: 'spot', spot_no: 'P08' },
    { col: 0, row: 5, type: 'wall' },
    { col: 1, row: 5, type: 'road' },
    { col: 2, row: 5, type: 'spot', spot_no: 'P09' },
    { col: 0, row: 6, type: 'wall' },
    { col: 1, row: 6, type: 'road' },
    { col: 2, row: 6, type: 'pillar' },
    { col: 0, row: 7, type: 'wall' },
    { col: 1, row: 7, type: 'road' },
    { col: 2, row: 7, type: 'spot', spot_no: 'P13' },
    { col: 0, row: 8, type: 'wall' },
    { col: 1, row: 8, type: 'road' },
    { col: 2, row: 8, type: 'spot', spot_no: 'P12' },
    { col: 0, row: 9, type: 'wall' },
    { col: 1, row: 9, type: 'road' },
    { col: 2, row: 9, type: 'pillar' },
    { col: 0, row: 10, type: 'wall' },
    { col: 1, row: 10, type: 'road' },
    { col: 2, row: 10, type: 'spot', spot_no: 'P14' },
    { col: 0, row: 11, type: 'wall' },
    { col: 1, row: 11, type: 'entrance' },
    { col: 2, row: 11, type: 'spot', spot_no: 'P15' },
  ],
};

export default layout;
